import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MLIcon from '../../../../../../components/MLIcon/MLIcon';
import { useLaunchUrl } from '../../../../contexts/LaunchContext';
import {
  REPORT_TYPE_INSIGHTS_LO,
} from '../../../../../actions/constants';
import {
  CLICK_INSIGHT_LO_MODAL_VIEW_ASSIGNMENTS,
  CLICK_INSIGHT_ASSIGNMENT_MODAL_VIEW_QUESTIONS,
} from '../../../../../analyticsEvents';
import style from './QQInsightLOAssignments.module.css';

const QQInsightLOAssignments = ({ courseId, loAssignments = [], reportType, sendAnalyticsEvent }) => {
  const getLaunchUrl = useLaunchUrl();
  const getUrlData = ({ id, activityId, tool }) => ({
    id,
    tool,
    course_id: courseId,
    activity_id: activityId,
  });

  const isLOReport = reportType === REPORT_TYPE_INSIGHTS_LO;
  const linkTitle = isLOReport ? 'View assignments' : 'View all questions';
  const iconType = isLOReport ? 'assignment' : 'learning_objective';
  const analyticsData = reportType === REPORT_TYPE_INSIGHTS_LO ?
    CLICK_INSIGHT_LO_MODAL_VIEW_ASSIGNMENTS :
    CLICK_INSIGHT_ASSIGNMENT_MODAL_VIEW_QUESTIONS;

  return (
    <div className={style.assignmentsWrapper}>
      {loAssignments.map(loAsgn => (
        <div key={loAsgn.id} className={style.assignmentRow}>
          <div className={style.assignmentNameWrapper}>
            {loAsgn.name && (
              <Fragment>
                <div className={style.assignmentIconWrapper}>
                  <MLIcon
                    width="15px"
                    height="15px"
                    type={iconType}
                    className={style.assignmentIcon}
                  />
                </div>
                <div className={style.assignmentName} title={loAsgn.name}>
                  {loAsgn.name}
                </div>
              </Fragment>
            )}
          </div>
          {loAsgn.tool && <div className={style.assignmentLink}>
            <a href={getLaunchUrl(getUrlData(loAsgn))} onClick={() => sendAnalyticsEvent(analyticsData)}>{linkTitle}</a>
          </div>}
        </div>
      ))}
    </div>
  );
};

QQInsightLOAssignments.propTypes = {
  courseId: PropTypes.string,
  reportType: PropTypes.string,
  loAssignments: PropTypes.array,
  sendAnalyticsEvent: PropTypes.func,
};

export default QQInsightLOAssignments;
